import React, { useState, useEffect, useRef } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Input from '../_Components/Input'
import { use } from '../../Helpers'
import { useDispatch } from 'react-redux'
import { updateDashboardData } from '../../Store/dashboardSlice'
import { call } from '../../Methods'

function OrderItemRow({ orderItem }) {
    const [_orderItem, _setOrderItem] = useState(null)
    const [_priceList, _setPriceList] = useState([])
    const [_sizeList, _setSizeList] = useState([])
    const [_substrateList, _setSubstrateList] = useState([])
    const [loading, setLoading] = useState(false)

    const getData = async () => {
        setLoading(true)
        let sizeListIds, substrateListIds;

        //get priceList for the item
        const _priceListResponse =
            await call.forLoggedUser.item.getPriceListByItemId({
                itemId: orderItem.itemId
            })
        if (_priceListResponse.success) {
            let _priceList = _priceListResponse.data
            sizeListIds = new Set(_priceList.map(p => String(p.sizeId)))
            substrateListIds = new Set(_priceList.map(p => String(p.substrateId)))
            _setPriceList([..._priceList]);
        }
        //get sizes and substrates for the item
        const _sizes = await call.forLoggedUser.size.getSizes({})

        if (_sizes.success) {
            const filteredSizes = normalize(_sizes.data).filter(s => sizeListIds.has(String(s.value)))
            _setSizeList(filteredSizes)
        }


        const _substrates = await call.forLoggedUser.substrate.getSubstrates({})
        if (_substrates.success) {
            const filteredSubstrates = normalize(_substrates.data).filter(s => substrateListIds.has(String(s.value)))
            _setSubstrateList(filteredSubstrates)
        }


        setLoading(false)
    }

    const normalize = (list)=>{
        return list.map(i=>{
            return {value: i.id, text: i.name}
        })
    }

    useEffect(() => {
        getData()
    }, [])


    useEffect(() => {
        _setOrderItem(orderItem)
    }, [orderItem])

    const getPrice = async () => {
        let priceItem = _priceList.find(
            p => (p.sizeId == _orderItem.sizeId) && (p.substrateId == _orderItem.substrateId)
        )
        if (priceItem) {
            let order_item = _orderItem
            order_item.price = priceItem.price
            order_item.totalAmount = priceItem.price * _orderItem.quantity
            _setOrderItem(order_item)
        }
    }

    return (
        <>
            {!loading && _orderItem && (
                <div
                    key={_orderItem.id}
                    data-index={_orderItem.id}
                    data-priceid={_orderItem.item_PriceId}
                    className='row sub-items-row'
                >
                    <span className='item-number'>{_orderItem.rowOrder}</span>
                    <Input
                        type={'text'}
                        label={'Name'}
                        fieldName={'itemName'}
                        col={{ default: 12, sm: 4, md: 3 }}
                        value={_orderItem.itemName}
                        disabled={true}
                    />

                    <Input
                        type={'select'}
                        label={'Size'}
                        fieldName={'sizeId'}
                        col={{ default: 12, sm: 4, md: 2 }}
                        data={_sizeList}
                        defaultValue={_orderItem.sizeId}
                        eventHandler={[
                            {
                                type: 'change',
                                handler: e => {
                                    let order_item = _orderItem
                                    order_item.sizeId = +e.target.value
                                    _setOrderItem(order_item)
                                    getPrice(_priceList)
                                }
                            }
                        ]}
                    />

                    <Input
                        type={'select'}
                        label={'Substrate'}
                        fieldName={'substrateId'}
                        col={{ default: 12, sm: 4, md: 2 }}
                        data={_substrateList}
                        defaultValue={_orderItem.substrateId}
                        eventHandler={[
                            {
                                type: 'change',
                                handler: e => {
                                    let order_item = _orderItem
                                    order_item.substrateId = e.target.value
                                    _setOrderItem(order_item)
                                    getPrice(_priceList)
                                }
                            }
                        ]}
                    />


                    <Input
                        type={'number'}
                        label={'Quantity'}
                        fieldName={'quantity'}
                        col={{ default: 6, sm: 2, md: 1 }}
                        value={_orderItem.quantity}
                    />

                    <Input
                        type={'number'}
                        label={'Price'}
                        fieldName={'singleItemPrice'}
                        col={{ default: 6, sm: 2, md: 1 }}
                        value={_orderItem.singleItemPrice}
                    />

                    <Input
                        type={'number'}
                        label={'Line total'}
                        fieldName={'totalPrice'}
                        disabled={true}
                        col={{ default: 6, sm: 2, md: 2 }}
                        value={_orderItem.totalPrice}
                    />
                    <div className='col-12 col-sm-2 col-md-1'>
                        <div className='input-box'>
                            <label></label>
                            <div>
                                <img
                                    className='row-delete'
                                    data-id={_orderItem.id}
                                    src='/trash.svg'
                                    onClick={(e) => { }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}


export default OrderItemRow